import { render, staticRenderFns } from "./CqlAddAttributeButton.vue?vue&type=template&id=672f9b24"
import script from "./CqlAddAttributeButton.vue?vue&type=script&lang=ts"
export * from "./CqlAddAttributeButton.vue?vue&type=script&lang=ts"
import style0 from "./CqlAddAttributeButton.vue?vue&type=style&index=0&id=672f9b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports